module.exports = __webpack_public_path__ + "img/通威太阳能_1.1359ff29.png";